
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M23.469 20.905l-6.262-6.261a9.401 9.401 0 00-2.563-13.046 9.401 9.401 0 100 15.61l6.261 6.261a1.813 1.813 0 102.564-2.564zm-14.058-2.9A8.603 8.603 0 01.817 9.41a8.594 8.594 0 118.594 8.593zm13.493 4.899a1.013 1.013 0 01-1.434 0l-6.098-6.099 1.433-1.433 6.099 6.099a1.013 1.013 0 010 1.433z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M9.621 1.62l-.02.799a6.978 6.978 0 015.29 2.645l.626-.498A7.778 7.778 0 009.621 1.62zM16.1 5.408l-.685.411c.149.247.282.504.4.768l.729-.323a7.85 7.85 0 00-.444-.856z","fill":"#E2E4EC"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"#fff"}})])])])
          )
        }
      }
    